// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__OYUY8","empty":"ModalGraph_empty__3lt_4"};